export default __webpack_public_path__ + "static/media/ico-planteo-dollar-selected.a05fa21b.svg";